<template>
    <div
        v-if="!loading && headshots.items && headshots.items.length"
        class="gallery"
    >
        <vue-glide
            :bullet="true"
            :perView="1"
            focusAt="center"
            :gap="0"
            :bound="true"
            :startAt="1"
            :key="headshots.items.length"
            type="carousel"
            @glide:run-after="fixSizing"
            ref="slider"
            v-model="active"
        >
            <vue-glide-slide
                v-for="(item, index) in headshots.items"
                :key="index"
            >
                <img
                    :src="headshots.items[index].image"
                />
            </vue-glide-slide>
            <template slot="control">
                <button
                    class="glide__previous"
                    data-glide-dir="<">
                    <icon
                        :icon="true"
                        glyph="arrow-left"
                    >
                    </icon>
                </button>
                <button
                    class="glide__next"
                    data-glide-dir=">">
                    <icon
                        :icon="true"
                        glyph="arrow-right"
                    >
                    </icon>
                </button>
            </template>
        </vue-glide>
    </div>
</template>

<script>
    import axios from 'axios';

    import {
        Glide, GlideSlide
    } from 'vue-glide-js';

    import 'vue-glide-js/dist/vue-glide.css';

    import icon from '../components/icon.vue';

    export default {
        name: 'gallery',
        components: {
            [Glide.name]: Glide,
            [GlideSlide.name]: GlideSlide,
            icon
        },
        props: {
            projectSlug: {
                type: String,
                default: 'palmstar',
                required: true
            }
        },
        data() {
            return {
                brian: 1,
                loading: true,
                active: 0, // zero-based slide
                headshots: [],
                errors: []
            };
        },
        created() {
            const self = this;
            axios.get(`/${self.projectSlug}/index.json`)
                .then((response) => {
                    self.active = 0;
                    self.headshots = response.data.headshots;
                })
                .catch((e) => {
                    self.errors.push(e);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        methods: {
            fixSizing() {
                this.$children[0].glide.update();
                return;
            }
        }
    };

</script>

<style>
    .gallery {
        transform-style: preserve-3d;

        .glide {
            .glide__slides {
                margin: 0;

                .glide__slide {
                    position: relative;

                    img {
                        display: block;
                        width: 100%;
                    }
                }
            }

            .glide__previous,
            .glide__next {
                @mixin transition-animation all, 250ms, ease-in, 0ms;
                @mixin position absolute, 50%, auto, auto, auto;
                @mixin transform translateY(-50%);
                background: none;
                border: var(--zero);
                border-radius: 50%;
                color: var(--color-white);
                cursor: pointer;
                font-size: var(--font-size-large);
                height: 40px;
                width: 40px;
                z-index: var(--z-index-base-max);

                .svg-icon {
                    @mixin position absolute, 50%, auto, auto, 50%;
                    @mixin transform translate3d(-50%, -50%, 0);
                }

                &:hover {
                    color: var(--color-alchemist-red);
                }
            }
            /* stylelint-disable no-descending-specificity */
            .glide__previous {
                left: 2%;

                .svg-icon {
                    margin: 0 0 0 -4px;
                }
            }

            .glide__next {
                right: 2%;

                .svg-icon {
                    margin: 0 0 0 3px;
                }
            }
            /* stylelint-enable no-descending-specificity */
            .glide__bullets {
                @mixin position absolute, auto, 0, 0, 0;
                margin-bottom: constant(safe-area-inset-bottom);
                margin-bottom: env(safe-area-inset-bottom);
                padding: 12px 0;
                text-align: center;
                width: 100%;

                button {
                    @mixin transition-animation background-color, 250ms, ease-in-out, 0ms;
                    background-color: color-mod(var(--color-white) alpha(25%));
                    border: var(--zero);
                    border-radius: 50%;
                    cursor: pointer;
                    display: inline-block;
                    height: 11px;
                    margin: 0 5px;
                    padding: var(--zero);
                    width: 11px;

                    &:hover {
                        background-color: var(--color-white);
                    }

                    &.glide__bullet--active {
                        background-color: var(--color-white);
                    }
                }
            }
        }

        @media (--breakpoint-l-max) {
            .glide {
                .glide__previous,
                .glide__next {
                    border-radius: 0;
                    color: var(--color-black);
                    height: 100px;
                    width: 10vw;
                }

                .glide__previous {
                    left: calc(3% - 12vw);
                }

                .glide__next {
                    right: calc(3% - 12vw);
                }
            }
        }
    }
</style>
